import { render } from "./Vulnerabilities.vue?vue&type=template&id=0fbe8a2b&scoped=true"
import script from "./Vulnerabilities.vue?vue&type=script&lang=js"
export * from "./Vulnerabilities.vue?vue&type=script&lang=js"

import "./Vulnerabilities.vue?vue&type=style&index=0&id=0fbe8a2b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fbe8a2b"]])

export default __exports__